import React, { useState, useEffect, useRef, forwardRef } from "react";
import clsx from 'clsx';
import {
  Card, CardContent,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import withScrollListener from "../../../../../hocs/with_scroll_listener.js";
import { compose } from 'redux';

import I18n from "../../../../../base/i18n.js.jsx";
import { itemWithKeys } from "../../../../../utils/utils.js.jsx";
import FormFields from "../../../../../base/form/form_fields.js.jsx";

import { AdminCompanyModel } from "../../../../../models/companies/admin/company_model.js.jsx";

import NavigationTabContent from "../../../components/navigation_tab_content.js";

import pageStyles from "../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../base_info_page.js.jsx";

const styles = theme => ({
});

const InvisibleMountedKey = "InvisibleMountedKey"
const VisibleMountedKey   = "VisibleMountedKey"

const CompanyInfoTabContent = forwardRef((props, ref) => {

  const {
    classes,
    scrollToElement,
    company = {},
  } = props;
  const { onItemChanged, visible } = props;

  const [errorData, setErrorData] = useState(props.errorData);
  const [tabKey, setTabKey]       = useState(visible ? VisibleMountedKey : InvisibleMountedKey);

  const formFields = AdminCompanyModel.formFields({
    item: company,
  });

  useEffect(() => {
    const { errorData } = props;
    setErrorData(errorData)
  }, [props.errorData]);

  useEffect(() => {
    if(tabKey === VisibleMountedKey) {
      return;
    }

    if(visible && tabKey === InvisibleMountedKey) {
      setTabKey(VisibleMountedKey);
    }
  }, [visible]);


  const onChange = (changedItem, changedField) => {
    onItemChanged(changedItem, changedField);
  }

  const mainInfoFields = ["name"];
  const mainInfoFieldsRef = useRef();

  const addressFields = ["address"];
  const addressFieldsRef = useRef();

  const peopleFields = ["people"];
  const peopleFieldsRef = useRef();

  const allFields = [
    ...mainInfoFields,
    ...addressFields,
    ...peopleFields,
  ];

  const fieldsGroupRefs = [
    mainInfoFieldsRef,
    addressFieldsRef,
    peopleFieldsRef,
  ]

  const allFieldsRefs = useRef();

  useEffect(() => {
    allFieldsRefs.current = {};
    fieldsGroupRefs.forEach((fieldsGroup) => {
      const current = fieldsGroup.current || {};
      const refs = current.fieldRefs;
      if(refs) {
        allFieldsRefs.current = {
          ...allFieldsRefs.current,
          ...refs
        }
      }
    })
  }, [])

  useEffect(() => {
    const { errorData } = props;
    setErrorData(errorData)
    if(!errorData) {
      return;
    }

    let { fields: fieldsErrorData = {} } = errorData;

    formFields.forEach(field => {
      if(field.type !== "nestedModelsArray" && field.type !== "nestedModel") {
        return;
      }
      if(!errorData[field.name]) {
        return;
      }
      fieldsErrorData[field.name] = errorData[field.name];
    })

    let firstErrorFieldRef;
    allFields.forEach((fieldName) => {
      if(firstErrorFieldRef) {
        return;
      }
      let fieldErrorInfo = fieldsErrorData[fieldName];
      let fieldRef       = allFieldsRefs.current[fieldName];

      if(fieldErrorInfo && fieldRef) {
        firstErrorFieldRef = fieldRef
      }
    })
    if(!firstErrorFieldRef) {
      return;
    }

    if(scrollToElement) {
      scrollToElement(firstErrorFieldRef)
    }

  }, [props.errorData]);

  return (
    <NavigationTabContent visible = { props.visible }
                          key = { tabKey } >
      <Card className = { clsx(classes.pageData, classes.pageDataCard) } >
        <CardContent className = { classes.pageDataContent } >
          <div className = { classes.cardTitle } >
            { I18n.t("admin.companies.company.field_group.main_info")}
          </div>
          <FormFields formFields = { formFields.filter(field => mainInfoFields.includes(field.name)) }
                      item = { itemWithKeys(company, mainInfoFields) }
                      errorData = { errorData }
                      onItemChange = { onChange }
                      defaultWeight = { 6 }
                      ref = { mainInfoFieldsRef }
                      />
        </CardContent>
      </Card>

      <Card className = { clsx(classes.pageData, classes.pageDataCard) } >
        <CardContent className = { classes.pageDataContent } >
          <div className = { classes.cardTitle } >
            { I18n.t("admin.companies.company.field_group.address")}
          </div>
          <FormFields formFields = { formFields.filter(field => addressFields.includes(field.name)) }
                      item = { itemWithKeys(company, addressFields) }
                      errorData = { errorData }
                      onItemChange = { onChange }
                      defaultWeight = { 6 }
                      ref = { addressFieldsRef }
                      />
        </CardContent>
      </Card>

      <Card className = { clsx(classes.pageData, classes.pageDataCard) } >
        <CardContent className = { classes.pageDataContent } >
          <div className = { classes.cardTitle } >
            { I18n.t("admin.companies.company.field_group.people")}
          </div>
          <FormFields formFields = { formFields.filter(field => peopleFields.includes(field.name)) }
                      item = { itemWithKeys(company, peopleFields) }
                      errorData = { errorData }
                      onItemChange = { onChange }
                      defaultWeight = { 6 }
                      ref = { peopleFieldsRef }
                      />
        </CardContent>
      </Card>
    </NavigationTabContent>
  );
});

CompanyInfoTabContent.defaultProps = {
}

export default compose(
  withScrollListener,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(CompanyInfoTabContent);
